import {memo, MouseEventHandler, useContext} from 'react'
import {DiagramConfigContext} from "../../context/DiagramConfigContext.tsx";

type DiagramNodeProps = {
    path: string,
    color: string,
    opacity: string | number,
    strokeOpacity: string | number,
    onClick: MouseEventHandler,
    onMouseOver: MouseEventHandler,
    onMouseLeave: MouseEventHandler,
    selected?: boolean
}
export const DiagramNode = memo(({
    path,
    color,
    onClick,
    onMouseOver,
    onMouseLeave,
    opacity,
    selected,
    strokeOpacity
}: DiagramNodeProps) => {
    const { config } = useContext(DiagramConfigContext)

    const selectedStyle = config.selected

    return (
        <path
            style={{
                cursor: 'pointer',
                filter: selected ? selectedStyle.filter : undefined,
            }}
            d={path}
            onClick={onClick}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
            fill={selected ? selectedStyle.color : (color || '#94a3b8')}
            opacity={opacity || 1}
            strokeOpacity={strokeOpacity || 0.9}
            strokeWidth={selected ? selectedStyle.strokeWidth : 1}
            stroke={selected ? selectedStyle.strokeColor : undefined}
        />
    )
})
